import React, { useEffect, useState } from 'react';
import PersonalDetails from '../../components/Sidebar/PersonalDetails';
import SocialMediaDetails from '../../components/Sidebar/SocialMediaDetails';
import ProfileDetails from '../../components/Sidebar/ProfileDetails';
import Heading from '../../components/Heading';
import { getUserDetails, updateUser, getUsersForFilters } from '../../api/users';
import countryData from '../../data/countryData';
import statesData from '../../data/statesData';
import countryStatesMapping from '../../data/countryStatesMapping';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useLocation, useNavigate } from 'react-router-dom';

const UserEdit = () => {
    const { state } = useLocation();
    const navigate = useNavigate();

    const [socialFields, setSocialFields] = useState([
        { label: 'LinkedIn Account Link', placeholder: 'Enter LinkedIn Account Link', name: 'linkedIn', value: '' },
        { label: 'Instagram Account Link', placeholder: 'Enter Instagram Account Link', name: 'instagram', value: '' },
        { label: 'Facebook Account Link', placeholder: 'Enter Facebook Account Link', name: 'facebook', value: '' },
        { label: 'Twitter Account Link', placeholder: 'Enter Twitter Account Link', name: 'twitter', value: '' },
        // { label: 'YouTube Account Link', placeholder: 'Enter YouTube Account Link', name: 'youtube', value: '' }, // REMOVED
        // { label: 'Website Link', placeholder: 'Enter Website Link', name: 'website', value: '' } // REMOVED
    ]);

    const [locationFields, setLocationFields] = useState([
        { label: 'Country', type: 'select', placeholder: 'Enter Country', name: 'country', value: '', data: countryData },
        { label: 'State', type: 'select', placeholder: 'Enter State', name: 'state', value: '', data: statesData },
        { label: 'City', placeholder: 'Enter City', name: 'city', value: '' },
        // { label: 'Address', placeholder: 'Enter Address', name: 'address', value: '' }, // REMOVED
        // { label: 'Pincode', placeholder: 'Enter Pincode', name: 'pincode', value: '' }, // REMOVED
        // { label: 'Landmark', placeholder: 'Enter Nearest Landmark', name: 'landmark', value: '' } // REMOVED
    ]);

    const [personalFields, setPersonalFields] = useState([
        { label: 'First Name', type: 'text', placeholder: 'Enter First Name', name: 'firstName', value: '', required: true },
        // { label: 'Middle name', type: 'text', placeholder: 'Enter Middle Name', name: 'middleName', value: '' }, // REMOVED
        { label: 'Last Name', type: 'text', placeholder: 'Enter Last Name', name: 'lastName', value: '' },
        { label: 'User Name', type: 'text', placeholder: 'Enter User Name', name: 'username', value: '', required: true },
        // { label: 'Display Name', type: 'text', placeholder: 'Enter Display Name', name: 'displayName', value: '' }, // REMOVED
        {
            label: 'Gender', type: 'select', placeholder: 'Choose Gender', name: 'gender', value: '', data: [
                { value: 'male', placeholder: 'male' },
                { value: 'female', placeholder: 'female' },
                { value: 'other', placeholder: 'other' },
            ]
        },
        { label: 'Email', type: 'text', placeholder: 'Enter Email', name: 'email', value: '', required: true },
        { label: 'Password', type: 'text', placeholder: 'Unchanged', name: 'password', value: '', disabled: true, hidden: true },
        { label: 'Mobile Number', type: 'number', placeholder: 'Enter Mobile Number', name: 'mobile', value: '' },
        // { label: 'DOB', type: 'date', placeholder: 'Enter Date Of Birth (DD/MM/YYYY)', name: 'dob', value: '' }, // REMOVED
        {
            label: 'Age Group', type: 'select', placeholder: 'Enter Age Group', name: 'ageGroup', value: '', data: [
                { value: 'Gen Alpha', placeholder: 'Gen Alpha (born 2010 - 2024)' },
                { value: 'Gen Z', placeholder: 'Gen Z (born 1997 - 2010)' },
                { value: 'Millennials', placeholder: 'Millennials (born 1981 – 1996)' },
                { value: 'Generation X', placeholder: 'Generation X (born 1965-1980)' },
                { value: 'Baby Boomers', placeholder: 'Baby Boomers (born 1946-1964)' },
            ]
        },
        // {
        //     label: 'User Type', type: 'select', placeholder: 'Enter User Type', name: 'userType', value: '', data: [
        //         { value: 'regular', placeholder: 'regular' },
        //         { value: 'ambassador', placeholder: 'ambassador' },
        //         { value: 'company', placeholder: 'company' },
        //         { value: 'ngo', placeholder: 'ngo' },
        //     ]
        // },
        { label: 'Own Referral Code', type: 'text', placeholder: 'Enter Referral Code', name: 'referralCode', value: '', disabled: true },
        { label: 'Referred By', type: 'select', placeholder: 'Select Referring User', name: 'referredBy', value: '', displayValue: '', data: [], disabled: true },
        { label: 'Referred By Code', type: 'text', placeholder: 'Referred By Code', name: 'referredByCode', value: '', disabled: true },
    ]);

    const [active, setActive] = useState(true);
    // Removed unused state variables to clean up code
    const [image, setImage] = useState(null);
    const [imageBase64, setImageBase64] = useState(null);
    const [comments, setComments] = useState('');
    const [openPersonal, setOpenPersonal] = useState(true);
    const [openSocial, setOpenSocial] = useState(true);
    const [openLocation, setOpenLocation] = useState(true);
    const [openAdminComment, setOpenAdminComment] = useState(true);

    const getVal = (fields, name) => {
        const f = fields && fields.find(x => x.name === name);
        return f ? f.value : null;
    }

    const handleSubmit = e => {
        console.log('Submitting with image: ');
        console.log(image);
        e.preventDefault();
        // Build payload only from fields that are visible and present on the page
        const buildFromFields = (fields) => {
            const out = {};
            fields.forEach(f => {
                if (!f) return;
                if (f.hidden) return; // skip hidden fields (eg. password)
                if (f.disabled) return; // skip non-editable fields (eg. referralCode)
                if (f.name === 'referredBy') {
                    if (f.value) {
                        out.referredBy = {
                            _id: f.value,
                            name: f.displayValue || f.value
                        };
                    }
                    return;
                }
                out[f.name] = f.value;
            });
            return out;
        };

        const data = {
            active: active,
            comments: comments,
            // Only mark image present when user selected a new File (not an existing URL)
            isImagePresent: image && image instanceof File ? true : false,
            // If a new File was selected, include base64 payload under `profilepic` so backend can handle upload
            profilepic: image && image instanceof File ? imageBase64 : null,
            ...buildFromFields(personalFields),
            ...buildFromFields(locationFields),
            ...buildFromFields(socialFields),
        };
        console.log(image);
        updateUser(state._id || state.userId, data, image, toast, navigate);
    }

    const handleCancel = () => {
        navigate(-1);
    };

    // Handler for country change to update state dropdown data
    const handleCountryChange = (countryValue) => {
        // Get states for selected country from mapping, or empty array if not found
        const statesForCountry = countryStatesMapping[countryValue] || [];

        // Update location fields
        setLocationFields(prevFields =>
            prevFields.map(field => {
                if (field.name === 'country') {
                    return { ...field, value: countryValue };
                }
                if (field.name === 'state') {
                    // Update state field data and clear value
                    return { ...field, data: statesForCountry, value: '' };
                }
                return field;
            })
        );
    };

    useEffect(() => {
        (async () => {
            try {
                // First load the user's details so personalFields gets populated with current values
                await getUserDetails(state._id || state.userId, socialFields, setSocialFields, locationFields, setLocationFields, personalFields, setPersonalFields, setImage, setActive, toast);

                // Update state field data based on the loaded country value
                setLocationFields(prev => {
                    const countryField = prev.find(f => f.name === 'country');
                    if (countryField && countryField.value) {
                        const statesForCountry = countryStatesMapping[countryField.value] || [];
                        return prev.map(field =>
                            field.name === 'state'
                                ? { ...field, data: statesForCountry }
                                : field
                        );
                    }
                    return prev;
                });

                // Then fetch users for the referredBy dropdown and attach to the existing personalFields state
                const users = await getUsersForFilters();
                const mapped = (users || []).map(u => {
                    const title = u.username || u.displayName || (u.name && (u.name.firstName || u.name.lastName) ? `${u.name.firstName || ''} ${u.name.lastName || ''}`.trim() : 'User');
                    return { value: u._id, placeholder: title, label: title, referralCode: u.referralCode };
                });
                console.log('getUsersForFilters -> fetched users count:', users ? users.length : 0, 'mapped count:', mapped.length);
                setPersonalFields(prev => {
                    const next = prev.map(f => (f.name === 'referredBy' || f.name === 'affiliatedBy') ? { ...f, data: mapped } : f);
                    console.log('personalFields after setting referredBy/affiliatedBy.data:', {
                        referredBy: next.find(x => x.name === 'referredBy'),
                        affiliatedBy: next.find(x => x.name === 'affiliatedBy')
                    });
                    return next;
                });

                // Set referredByCode if referredBy is selected
                const currentReferredBy = personalFields.find(f => f.name === 'referredBy');
                if (currentReferredBy && currentReferredBy.value) {
                    const referrer = mapped.find(u => u.value === currentReferredBy.value);
                    if (referrer) {
                        setPersonalFields(prev => prev.map(f => f.name === 'referredByCode' ? { ...f, value: referrer.referralCode || '' } : f));
                    }
                }
            } catch (err) {
                console.error('Failed to load user details or referred-by users', err);
            }
        })();
        // eslint-disable-next-line
    }, []);

    return (
        <div className="flex overflow-hidden flex-col justify-center items-center w-full">
            <div className="flex w-full">
                <div className="flex flex-col pb-5 ml-6 mt-7 mr-9 w-full max-md:mr-2.5">
                    <section className="flex flex-col self-stretch mt-0 w-full max-md:max-w-full">
                        <div className="flex justify-between">
                            <Heading
                                text={"Update User Form"}
                            />
                            <div className="flex justify-between items-center">
                                <label className="inline-flex items-center me-5 cursor-pointer">
                                    <span className="ms-3 text-base font-medium text-gray-900 dark:text-gray-300 mr-2">Inactive</span>
                                    <input type="checkbox" name={'active'} value={active} className="sr-only peer" onChange={() => setActive(!active)} checked={active} />
                                    <div className="relative w-11 h-6 bg-white border-black ring-1 ring-secondary rounded-full peer dark:bg-white peer-focus:ring-primary dark:peer-focus:ring-primary peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-0.5 after:start-[2px] after:bg-secondary after:border-secondary peer-checked:after:bg-white after:rounded-full after:h-5 after:w-5 after:transition-all dark:border-navBtn peer-checked:ring-primary peer-checked:bg-primary"></div>
                                    <span className="ms-3 text-base font-medium text-gray-900 dark:text-gray-300">Active</span>
                                </label>
                            </div>
                        </div>

                        <div className="mt-6">
                            {/* Personal Details Card (accordion) */}
                            <div className=" rounded-md mb-4 bg-white">
                                <button type="button" onClick={() => setOpenPersonal(!openPersonal)} className="w-full px-4 py-3 flex items-center justify-between">
                                    <h2 className="text-lg font-semibold text-gray-800">Personal Details</h2>
                                    <svg className={`w-5 h-5 transform ${openPersonal ? 'rotate-180' : ''}`} viewBox="0 0 20 20" fill="currentColor">
                                        <path fillRule="evenodd" d="M5.23 7.21a.75.75 0 011.06.02L10 10.94l3.71-3.71a.75.75 0 011.08 1.04l-4.25 4.25a.75.75 0 01-1.06 0L5.21 8.27a.75.75 0 01.02-1.06z" clipRule="evenodd" />
                                    </svg>
                                </button>
                                {openPersonal && (
                                    <PersonalDetails
                                            personalFields={personalFields}
                                            setPersonalFields={setPersonalFields}
                                            image={image}
                                            setImage={setImage}
                                            setImageBase64={setImageBase64}
                                        />
                                )}
                            </div>

                            {/* Social Media Card (accordion) */}
                            <div className=" rounded-md mb-4 bg-white">
                                <button type="button" onClick={() => setOpenSocial(!openSocial)} className="w-full px-4 py-3 flex items-center justify-between">
                                    <h2 className="text-lg font-semibold text-gray-800">Social Media Details</h2>
                                    <svg className={`w-5 h-5 transform ${openSocial ? 'rotate-180' : ''}`} viewBox="0 0 20 20" fill="currentColor">
                                        <path fillRule="evenodd" d="M5.23 7.21a.75.75 0 011.06.02L10 10.94l3.71-3.71a.75.75 0 011.08 1.04l-4.25 4.25a.75.75 0 01-1.06 0L5.21 8.27a.75.75 0 01.02-1.06z" clipRule="evenodd" />
                                    </svg>
                                </button>
                                {openSocial && (
                                    <SocialMediaDetails
                                        socialFields={socialFields}
                                        setSocialFields={setSocialFields}
                                    />
                                )}
                            </div>

                            {/* Location Card (accordion) */}
                            <div className=" rounded-md mb-4 bg-white">
                                <button type="button" onClick={() => setOpenLocation(!openLocation)} className="w-full px-4 py-3 flex items-center justify-between">
                                    <h2 className="text-lg font-semibold text-gray-800">Location Details</h2>
                                    <svg className={`w-5 h-5 transform ${openLocation ? 'rotate-180' : ''}`} viewBox="0 0 20 20" fill="currentColor">
                                        <path fillRule="evenodd" d="M5.23 7.21a.75.75 0 011.06.02L10 10.94l3.71-3.71a.75.75 0 011.08 1.04l-4.25 4.25a.75.75 0 01-1.06 0L5.21 8.27a.75.75 0 01.02-1.06z" clipRule="evenodd" />
                                    </svg>
                                </button>
                                {openLocation && (
                                    <ProfileDetails
                                        locationFields={locationFields}
                                        setLocationFields={setLocationFields}
                                        onCountryChange={handleCountryChange}
                                    />
                                )}
                            </div>
                        </div>

                        <div className="mt-8">
                            <div className=" rounded-md bg-white">
                                <button type="button" onClick={() => setOpenAdminComment(!openAdminComment)} className="w-full px-4 py-3 flex items-center justify-between">
                                    <h2 className="text-lg font-semibold text-gray-800">Admin Comment</h2>
                                    <svg className={`w-5 h-5 transform ${openAdminComment ? 'rotate-180' : ''}`} viewBox="0 0 20 20" fill="currentColor">
                                        <path fillRule="evenodd" d="M5.23 7.21a.75.75 0 011.06.02L10 10.94l3.71-3.71a.75.75 0 011.08 1.04l-4.25 4.25a.75.75 0 01-1.06 0L5.21 8.27a.75.75 0 01.02-1.06z" clipRule="evenodd" />
                                    </svg>
                                </button>
                                {openAdminComment && (
                                    <div className="p-4 ">
                                        <textarea
                                            className="w-full p-2 border border-gray-300 rounded-md"
                                            rows="4"
                                            placeholder="Enter reason for the update..."
                                            value={comments}
                                            onChange={(e) => setComments(e.target.value)}
                                        />
                                    </div>
                                )}
                            </div>
                        </div>

                        {/* --- FormActions component replaced with Save/Cancel buttons --- */}
                        <div className="flex justify-end gap-4 mt-8">
                            <button type="button" onClick={handleCancel} className="px-6 py-2 text-base font-semibold text-gray-700 bg-white border border-gray-300 rounded-md shadow-sm hover:bg-gray-50">
                                Cancel
                            </button>
                            <button type="submit" onClick={handleSubmit} className="px-6 py-2 text-base font-semibold text-white bg-primary border border-transparent rounded-md shadow-sm hover:bg-primary-dark">
                                Save
                            </button>
                        </div>

                    </section>
                </div>
            </div>
            <ToastContainer
                position="top-right"
                autoClose={1000}
            />
        </div>
    );
}

export default UserEdit;